import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon'

const LogoutIcon = (props: SvgIconProps) => (
  /* eslint-disable-next-line react/jsx-props-no-spreading */
  <SvgIcon width="27" height="27" viewBox="0 0 27 27" fill="none" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      // eslint-disable-next-line max-len
      d="M4.00011 5C4.00011 3.34315 5.34326 2 7.00011 2H17.0176C18.6744 2 20.0176 3.34315 20.0176 5V9H18.0176V5C18.0176 4.44771 17.5698 4 17.0176 4H7.00011C6.44783 4 6.00011 4.44772 6.00011 5L6 22C6 22.5523 6.44772 23 7 23H17.0174C17.5697 23 18.0174 22.5523 18.0174 22L18.0176 18H20.0176L20.0174 22C20.0174 23.6569 18.6743 25 17.0174 25H7C5.34314 25 4 23.6569 4 22L4.00011 5Z"
      fill="#0B7CB7"
    />
    <rect x="12" y="12.3052" width="13.1929" height="1.64911" fill="#0B7CB7" />
    <rect x="21.8823" y="9" width="5.8404" height="1.64911" transform="rotate(45 21.8823 9)" fill="#0B7CB7" />
    <rect
      width="5.88857"
      height="1.64911"
      transform="matrix(-0.707107 0.707107 0.707107 0.707107 24.8459 11.9637)"
      fill="#0B7CB7"
    />
  </SvgIcon>
)

export default LogoutIcon
